
import React from "react";
import { VariantOptionsManager } from "@/components/variant-options/VariantOptionsManager";

export default function VariantOptions() {
  return (
    <div className="container mx-auto px-4 py-6">
      <VariantOptionsManager />
    </div>
  );
}
